import { IBranch } from '@/_types';
import { ISavedBranch } from '@/_store/types';

export const handleScrollToBranch = (
  selectedBranch: ISavedBranch | null,
  branch: ISavedBranch | null,
  branchRefs: React.RefObject<Record<string, HTMLDivElement | null>>,
  setSelectedBranch: (branch: ISavedBranch | null) => void
) => {
  const activeBranch = selectedBranch ?? branch;
  if (activeBranch?.id) {
    branchRefs.current[activeBranch.id]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  }
  if (!selectedBranch && branch) {
    setSelectedBranch(branch);
  }
};

export const formatBranchData = (branch: ISavedBranch) => ({
  id: branch.id,
  menu_id: branch.menu_id || '',
  address: branch.address,
  name: branch.name,
  location: branch.location,
  slug: branch.slug,
  future_delivery_order_time: branch.future_delivery_order_time,
  future_self_pickup_order_time: branch.future_self_pickup_order_time,
  work_hour_start: branch.work_hour_start,
  work_hour_end: branch.work_hour_end,
  is_work_24_7: branch.is_work_24_7,
  delivery_time: branch.delivery_time,
  shipper_id: branch.shipper_id,
});
